// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__hqvo7","login-button":"Login_login-button__-AFh6"};